import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';
import { getENV } from 'src/app/shared/constants/env';
import { LANGUAGE, LANGUAGE_BRIEF } from 'src/app/shared/constants/language';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  public languages = LANGUAGE;
  public languagesBrief = LANGUAGE_BRIEF;
  public selectedLanguage: string = 'en';
  public currentEnv = getENV();
  constructor(
    private translateService: TranslateService,
    private config: PrimeNGConfig,
  ) {}

  ngOnInit(): void {
    this.changeLanguageNgPrime();
  }

  public changeLanguage(language: string): void {
    this.translateService.use(language);
    this.changeLanguageNgPrime();
  }

  private changeLanguageNgPrime(): void {
    this.translateService
      .get('primeng')
      .subscribe(res => this.config.setTranslation(res));
  }
}
